import { Component, OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {LabourService} from '../../service/labour.service'
import { SharedService } from 'app/modules/common/services/shared-service';
@Component({
    selector: 'app-add-calander',
    templateUrl: './add-calander.component.html',
    styleUrls: ['./add-calander.component.scss'],
    standalone: false
})
export class AddCalanderComponent implements OnInit {
  regionName :string;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddCalanderComponent>,
    public labourService :LabourService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.regionName=this.data.comunidad;
  }

  onSubmit()
  {
    this.pathchRegion();
    if(this.labourService.poblacionForm.valid)
    {
      this.labourService.addAddPoblacion(this.labourService.poblacionForm.value).subscribe(res=>{
        if(res.result==1)
        {
          this.sharedService.ShowSnackBar('Este nombre ya existe como region o población ', 'Okay', 2000);
          this.labourService.poblacionForm.reset();
          this.dialogRef.close(0);
        }else
        {
          this.sharedService.ShowSnackBar('Insertado correctamente ', 'Okay', 2000);
          this.labourService.poblacionForm.reset();
          this.dialogRef.close(this.data.nodeId);
        }     
      }, err => {
        console.error(err);
      })
    }
    
  }

  onClose()
  {
    this.labourService.poblacionForm.reset();
    this.dialogRef.close(0);
  }

  pathchRegion()
  {
    this.labourService.poblacionForm.patchValue({
      Comunidad:this.regionName
    })
  }

}
